import { type ReactElement, useState } from 'react';
import { twMerge } from 'tailwind-merge';

interface ITabProps {
  defaultIndex?: number;
  index?: number;
  onChange?: (index: number) => void;
  className?: string;
  children: ReactElement<any>[];
}

const TabList = ({ defaultIndex = 0, index, onChange, children, className }: ITabProps) => {
  const [bindIndex, setBindIndex] = useState(defaultIndex);

  const activeIndex = index !== undefined ? index : bindIndex;

  const changeTab = (newIndex: number) => {
    if (onChange) onChange(newIndex);
    setBindIndex(newIndex);
  };

  const items = children as ReactElement<any>[];

  return (
    <div className='wrapper'>
      <div className={twMerge(['shadow-tabsBorder', className])}>
        <div className='w-1/4 flex relative flex-col sm:flex-row'>
          {items.map(({ props: { index, label, labelClassName } }) => (
            <div
              key={`tab-${index}`}
              onClick={() => changeTab(index)}
              className={twMerge([
                'relative sm:text-center hover:bg-gray-100 hover:after:bg-gray-200 font-medium py-3 px-4 cursor-pointer after:content-[""] after:absolute after:bottom-0 after:left-0 after:h-px after:w-full after:bg-transparent -mb-0',
                activeIndex === index && 'after:bg-green-500 hover:after:bg-green-500 after:h-[2px] font-semibold',
                labelClassName,
              ])}
            >
              <span className='px-3 py-2 rounded'>{label}</span>
            </div>
          ))}
        </div>
      </div>
      <div className='w-full flex'>
        {items
          .filter(({ props }) => activeIndex === props.index)
          .map(({ props }) => (
            <div {...props} className='selected w-full' key={`tab-content-${props.index}`} />
          ))}
      </div>
    </div>
  );
};

export default TabList;
